import {useFedopsLogger, usePanorama} from '@wix/yoshi-flow-editor'
import {useMemo} from 'react'
import {createLogger} from '../services/logger'

export const useLogger = () => {
  const fedops = useFedopsLogger()
  const panoramaClient = usePanorama()

  const logger = useMemo(() => createLogger({fedops, panoramaClient}), [fedops, panoramaClient])

  return logger
}
